import getConfig from 'next/config';
import structureData from '../../../util/Format.util';
import { viewItemListAnalytics } from '../../../util/gtm';
import { getCookie, getTokenFromCookies, setCookie } from '../../hooks/useCookie';
import { setLocalStorage, getLocalStorage } from '../../hooks/useLocalStorage';
import { getHandsets } from '../../integration/handset.api';
import { getTariffs } from '../../integration/tariff.api';
import { OFFER_TYPE_CODE } from '../shared/Constants';

const { publicRuntimeConfig } = getConfig();
const { POSTPAY } = OFFER_TYPE_CODE;

export const onGetStandaloneHandsets = async ({
  graphql,
  localStorage,
  selectedSubscriptionOffer,
}) => {
  setLocalStorage('STANDALONE_HANDSET', true);
  try {
    let variable = {};
    if (!getTokenFromCookies()) {
      variable = {
        offerType: 'POSTPAY',
        cartOfferID: localStorage.hasValue('HANDSET_BE_OFFERID')
          ? parseInt(getLocalStorage('HANDSET_BE_OFFERID'), 10)
          : null,
        reference: getLocalStorage('PROSPECTUUID'),
      };
      if (!variable.cartOfferID) delete variable.cartOfferID;
      if (!localStorage.hasValue('PROSPECTUUID') && !localStorage.hasValue('REF')) {
        delete variable.reference;
      }
    } else {
      let subscription = selectedSubscriptionOffer;
      if (getCookie('cart_Type') === 'CHANGE_OFFER' && !subscription) {
        if (getCookie('selected_subscription')) {
          [subscription] = JSON.parse(getCookie('selected_subscription'));
        } else if (getCookie('CO_CATALOG_CODE')) {
          subscription = {
            catalogOfferCode: getCookie('CO_CATALOG_CODE'),
          };
        }
      }
      /* eslint-disable no-nested-ternary */
      variable = {
        offerType: 'POSTPAY',
        cartOfferID: localStorage.hasValue('HANDSET_BE_OFFERID')
          ? parseInt(getLocalStorage('HANDSET_BE_OFFERID'), 10)
          : null,
        reference: getCookie('reference'),
        accountId: Number(getCookie('account_Id')),
        channel: getCookie('channel')
          ? getCookie('channel')
          : `${publicRuntimeConfig.NEXT_PUBLIC_CHANNEL}`,
        email: getCookie('email_Address'),
        cartType: getCookie('cart_Type'),
        offerCode: subscription
          ? subscription?.simOnly
            ? 'SIMO_HANDSET_UPGRADE'
            : subscription?.catalogOfferCode
          : '',
        token: getTokenFromCookies(),
      };
      if (getCookie('reference')) {
        delete variable.accountId;
        delete variable.offerType;
        delete variable.cartOfferID;
      } else {
        delete variable.reference;
        delete variable.cartOfferID;
      }
      if (variable?.offerCode === '') delete variable.offerCode;
    }

    const result = await getHandsets({ graphql, variables: variable });
    if (getCookie('cart_Type') === 'CROSS_SELL') {
      localStorage.setLocalStorage('REF', result.getHandsets.reference);
      setCookie('CS', 'reference', result?.getHandsets?.reference);
    }

    if (!localStorage.hasValue('PROSPECTUUID')) {
      localStorage.setLocalStorage('PROSPECTUUID', result.getHandsets.reference);
    }
    if (getCookie('cart_Type') === 'NEW_ACQUISITION') {
      setCookie('ACQ', 'reference', result?.getHandsets?.reference);
    }
    viewItemListAnalytics('Billpay_handsets', result);
    return { result };
  } catch (err) {
    console.error(err);
    return { error: err };
  }
};
export const onPortingChangeService = async ({ graphql, portIn, handsetCodeNew }) => {
  try {
    const variables = {
      portIn,
      serviceGroupCode: 'MOBILE',
      simOnly: false,
      equipmentCode: handsetCodeNew,
      reference:
        getCookie('reference') || getLocalStorage('PROSPECTUUID') || getLocalStorage('REF'),
      offerType: POSTPAY,
    };
    if (getCookie('cart_Type') === 'CHANGE_OFFER') delete variables.portIn;
    const offerData = await getTariffs({ graphql, variables });
    const result = {
      offers: offerData?.tariffs?.map(offer => structureData(offer, graphql)),
      discounts: offerData?.discounts,
    };
    return result;
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const onload = async ({ graphql, localStorage }) => {
  try {
    let result = {};
    let handsetList = null;
    let brandList = null;

    const { result: devices } = await onGetStandaloneHandsets({
      graphql,
      localStorage,
    });

    if (devices) {
      handsetList = devices.getHandsets.handsets;
      brandList = devices.getHandsets.manufacturers;
    }

    result = {
      ...result,
      handsetList,
      brandList,
    };

    return result;
  } catch (error) {
    console.error('something went wrong on load of /shop/mobile', error);
  }
};
